module.exports = __webpack_public_path__ + "images/android-chrome-256x256.cdd4241bb20cd356ca818f68d2e29271.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/android-chrome-256x256.png
// module id = 987
// module chunks = 0